import React from "react";
import { useLang } from "../i18n";
import { InventoryDownloadCard } from "./InventoryDownload";

export default function Catalog() {
  const { t } = useLang();
  const d = t.catalog.dl;
  return (
    <main className="max-w-[1280px] mx-auto px-6 py-16 lg:py-24" data-testid="catalog-page">
      <div className="text-center mb-10">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-800">{d.pageTitle}</h1>
        <p className="mt-4 text-slate-500 max-w-2xl mx-auto text-lg">{d.pageSubtitle}</p>
      </div>
      <InventoryDownloadCard />
    </main>
  );
}
